// Shared code for TextField and TextArea
import classNames from 'classnames'
import React, { MutableRefObject, ReactNode, useRef } from 'react'

export interface TextInputProps {
    id: string
    name: string
    value: string

    className?: string
    elementRef?: (element: HTMLElement | null) => void
    bordered?: boolean
    description?: string
    hiddenLabel?: boolean
    error?: string
    isDisabled?: boolean
    isRequired?: boolean
    label?: string
    labelClass?: string
}

interface TextInputWrapperProps extends TextInputProps {
    children: ReactNode
}

export const TextInputWrapper = (props: TextInputWrapperProps): JSX.Element => {
    const element: MutableRefObject<null | HTMLElement> = useRef(null)

    const {
        bordered,
        children,
        hiddenLabel,
        id,
        value,
        description,
        error,
        isDisabled,
        isRequired,
        label,
        labelClass,
    } = props

    const className = classNames('textfield', props.className, {
        'textfield--hidden-label': hiddenLabel,
        'textfield--bordered': bordered,
        'is-invalid': error,
        'is-disabled': isDisabled,
        'is-dirty': value,
    })

    const renderLabel = () => (
        <label className={classNames('textfield__label', labelClass)} htmlFor={id}>
            {label}
            {isRequired && ' *'}
        </label>
    )

    return (
        <div
            className={className}
            ref={(el: HTMLElement | null) => {
                if (el && element.current !== el) {
                    element.current = el

                    if (props.elementRef) {
                        props.elementRef(el)
                    }
                }
            }}
        >
            {bordered && renderLabel()}
            <div className="textfield__inner">
                {children}
                {!bordered && renderLabel()}
            </div>
            {description && <div className="textfield__description">{description}</div>}
            {error && <div className="textfield__error">{error}</div>}
        </div>
    )
}
